import React from 'react'
import PropTypes from 'prop-types'
import { subDays } from 'date-fns'

import { Button, Page } from '@fielded/shared-ui'
import { hasFeature } from '../../../van-shared/utils/features'
import withConfig from '../../../van-shared/hoc/withConfig'
import { withUser } from '../../../common/AuthenticationProvider'

/**
 * Check if the current date is the previous to last day of the period or earlier,
 * for a given program.
 * @param {Object} currentPeriod - The object containing the program current period definition.
 * @returns {boolean} - Returns false if today is the period effective end day or later,
 * true otherwise.
 */
const beforePeriodLastDay = (currentPeriod) => {
  const now = new Date()
  // Note: effectiveEndDate is in fact the effective end "time".
  // That is, it contains a UTC timestamp with the end of the effective end-of-period day.
  const prevToLastDay = subDays(currentPeriod.effectiveEndDate, 1)
  return now <= prevToLastDay
}

const Footer = ({onClickSave, onClickSubmit, loading, disabled, config, user, period}) => {
  const isFacilityUser = user.location.level === 'sdp'

  const mustShowSaveButton = hasFeature(config.features, 'stockReportingSave') &&
                             isFacilityUser &&
                             beforePeriodLastDay(period)

  return (
    <Page.Footer>
      {!mustShowSaveButton && (
        <Button
          fill='outline'
          colorVariant='brand'
          size='large'
          onClick={onClickSubmit}
          id='footerSubmitBtn'
          className='submit-with-hint'
          loading={loading}
          disabled={disabled}
        >
        Submit stock count
        </Button>
      )}
      {mustShowSaveButton && (
        <Button
          fill='outline'
          colorVariant='brand'
          size='large'
          onClick={onClickSave}
          id='footerSaveBtn'
          className='submit-with-hint'
          loading={loading}
          disabled={disabled}
        >
          Save
        </Button>
      )}
    </Page.Footer>
  )
}

Footer.propTypes = {
  onClickSubmit: PropTypes.func.isRequired
}

export default withUser(withConfig(Footer))
